<template>
  <div>

    <loader v-if="!isLoaded" class="table-loader"></loader>

    <form novalidate v-show="isLoaded">
      <div class="row wizard-tab-container">
        <div class="col-lg-8">

          <h1 class="page-title">{{'protocol.support' | trans}}: <span v-if="protocols">{{protocols.title}}</span></h1>
          <h3 class="page-sub-title">{{'protocol.conductingTherapeuticSession' |
            trans}}</h3>

          <h3 class="step-title mt-4" v-if="activeStep.taskType">
            {{'protocol.checkList' | trans}}:
            {{activeStep.taskType.title}}</h3>

          <div class="alert alert-warning" v-if="stimulusListEmpty">
            {{'protocol.stimulus_list_empty' | trans}}
          </div>

          <h3 class="step-title"> {{'protocol.today_support_stimulus' | trans}}</h3>

          <div class="row mt-2 mb-3" v-if="isPreviousDateSession && protocolData && protocolData.endDate" ref="maxTotalAtemptsCountError" id="maxTotalAtemptsCountError">
            <div class="col-12">
              <div class="alert-danger text-center" v-if="showDatePrevious">
                {{'protocol.enter_another_session_date' | trans}} <strong>{{minDate | toLocaleDateTime}}</strong>
              </div>
              <div class="alert-secondary text-center" v-if="!showDatePrevious">
                {{'protocol.end_session_date' | trans}}: <strong>{{minDate | toLocaleDateTime}}</strong>
              </div>
            </div>
          </div>

          <div v-if="!isMobile && todayStimulList" class="position-relative wrapper-loader">
            <loader v-if="(!(previousDate && previousTime && previousTime.HH && previousTime.mm) && (isBCBA || isCurator) && isPreviousDateSession) || showDatePrevious" class="table-loader position-absolute without-img"
                    messages=""></loader>
            <table class="table table-sm mt-2">
              <thead class="thead-light">
              <tr>
                <th class="title-cell">{{'protocol.stimuluses' | trans}}</th>
                <th>{{'protocol.repeat' | trans}}</th>
                <th colspan="2">{{'protocol.result' | trans}}</th>
              </tr>
              </thead>
              <tbody class="gray-700">
              <tr v-for="(stimul,index) in todayStimulList" :key="stimul.globalUuid" v-if="!stimul.moveToPrevPhase">
                <td>{{stimul.description}}</td>
                <td>{{stimul.iterationIndex}} / {{stimul.iterationCount}}</td>
                <td class="wide-cell">
                  <div
                      class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                      v-for="(label, key) in stimul.type.answers">
                    <div
                        class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                      <input :id="'id'+index + stimul.id +key"
                             type="radio" class="mdc-radio__native-control"
                             v-model="stimul.answer"
                             :disabled="stimul.disabled"
                             :name="'radios'+index + stimul.globalUuid"
                             :key="label.title"
                             :value="label.title"
                             v-on:change="attemptChange(label.id, stimul)">
                      <div class="mdc-radio__background" :class="{'disabled' : stimul.disabled}"
                           :style="{background: label.color}">
                        <div class="mdc-radio__outer-circle"></div>
                        <div class="mdc-radio__inner-circle"></div>
                        <label :for="'id'+index + stimul.globalUuid + key">{{label.title}}</label>
                      </div>
                    </div>
                  </div>
                  <button type="button"
                          class="btn return-btn"
                          :disabled="!stimul.disabled"
                          @click.prevent="backToPreviousAttempt(stimul.globalUuid)">
                    <i class="material-icons mdc-button__icon">undo</i>
                  </button>
                </td>
                <td class="text-right action-cell">
                  <button type="button"
                          class="btn btn-link btn-link__table-text"
                          v-if="stimul.toRotation"
                          @click.prevent="goToPrevPhase(stimul.globalUuid)">
                    {{'protocol.to_prev_phase' | trans}}
                  </button>
                </td>
              </tr>
              </tbody>
            </table>


            <div class="box-shadow mt-2 mb-4" v-if="allStimulList">
              <h3 class="step-title" v-on:click="visible = !visible">
                {{'protocol.support_stimulus' | trans}}
                <button type="button" v-if="allStimulList.length"
                        class="btn btn-link btn-link__text float-right">
                  <span :class="{'arrow-down': visible, 'arrow-up':!visible}"></span>
                </button>
              </h3>
              <table class="table table-sm mt-2" v-if="visible">
                <thead class="thead-light">
                <tr>
                  <th>{{'protocol.stimuluses' | trans}}</th>
                  <th>{{'protocol.repeat' | trans}}</th>
                  <th>{{'dro.list.interval' | trans}}</th>
                </tr>
                </thead>
                <tbody class="gray-700">
                <tr v-for="(stimul,index) in allStimulList" :key="stimul.globalUuid">
                  <td>{{stimul.description}}</td>
                  <td>{{stimul.iterationIndex}} / {{stimul.iterationCount}}</td>
                  <td>
                    {{getInterval(stimul.intervalType)}}
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

          </div>

          <div v-if="isMobile && todayStimulList">

            <div class="mobile-table">

              <div class="mobile-table__head">
                <div class="cell">{{'protocol.stimuluses' | trans}}</div>
                <div class="cell">{{'protocol.repeat' | trans}}</div>
              </div>

              <div class="mobile-table__body">
                <div class="mobile-table__row"
                     v-for="(stimul,index) in todayStimulList" :key="stimul.globalUuid" v-if="!stimul.moveToPrevPhase">

                  <div class="container-load" v-if="stimul.answer">
                    <svg viewbox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" :class="{'animate': stimul.answer}">
                      <path d="M 18 32.34 l -8.34 -8.34 -2.83 2.83 11.17 11.17 24 -24 -2.83 -2.83 z" stroke="#3da35a" fill="transparent"/>
                    </svg>
                  </div>

                  <div>
                    <div class="cell">{{stimul.description}}</div>
                    <div class="cell">
                      <button type="button"
                              class="btn btn-link btn-link__table-text"
                              v-if="stimul.toRotation"
                              @click.prevent="goToPrevPhase(stimul.globalUuid)">
                        {{'protocol.to_prev_phase' | trans}}
                      </button>
                    </div>
                    <div class="cell">{{stimul.iterationIndex}} / {{stimul.iterationCount}}</div>
                  </div>
                  <div class="mt-2 stimul-row">
                    <div
                        class="mdc-radio-wrapper mdc-form-field stimul-radio-wrapper"
                        v-for="(label, key) in stimul.type.answers">
                      <div
                          class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                        <input :id="'id'+index + stimul.id +key"
                               type="radio" class="mdc-radio__native-control"
                               v-model="stimul.answer"
                               :disabled="stimul.disabled"
                               :name="'radios'+index + stimul.globalUuid"
                               :key="label.title"
                               :value="label.title"
                               v-on:change="attemptChange(label.id, stimul)">
                        <div class="mdc-radio__background" :class="{'disabled' : stimul.disabled}"
                             :style="{background: label.color}">
                          <div class="mdc-radio__outer-circle"></div>
                          <div class="mdc-radio__inner-circle"></div>
                          <label :for="'id'+index + stimul.globalUuid + key">{{label.title}}</label>
                        </div>
                      </div>
                    </div>
                    <button type="button"
                            class="btn return-btn"
                            :disabled="!stimul.disabled"
                            @click.prevent="backToPreviousAttempt(stimul.globalUuid)">
                      <i class="material-icons mdc-button__icon">undo</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div class="box-shadow mt-2 mb-4" v-if="allStimulList">
              <h3 class="step-title" v-on:click="visible = !visible">
                {{'protocol.support_stimulus' | trans}}
                <button type="button"  v-if="allStimulList.length"
                        class="btn btn-link btn-link__text float-right">
                  <span :class="{'arrow-down': visible, 'arrow-up':!visible}"></span>
                </button>
              </h3>

              <div class="mobile-table" v-if="visible">
                <div class="mobile-table__body">
                  <div class="mobile-table__row"
                       v-for="(stimul,index) in allStimulList" :key="stimul.globalUuid">
                    <div class="mobile-table__head">
                      {{stimul.description}}
                    </div>

                    <div class="description mt-2">
                      <p>{{'protocol.repeat' | trans}}:
                        {{stimul.iterationIndex}} / {{stimul.iterationCount}}</p>
                      <p>{{'dro.list.interval' | trans}}:
                        {{getInterval(stimul.intervalType)}}</p>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
      </div>
      <div class="col-lg-4">
        <instruction :text="execution"
                     :header="'protocol.execution' | trans"
                     :short-text-length="180">
        </instruction>
      </div>
  </div>

  <div class="form-group row stage-button">
    <div class="col-md-12">

      <button type="submit"
              v-if="!isClient"
              :disabled="disabledSave || (!(previousDate && previousTime.HH && previousTime.mm) && (isBCBA || isCurator) && isPreviousDateSession) || showDatePrevious"
              class="btn btn-primary btn-sm mr-2 mt-2 mt-md-0"
              @click.prevent="saveStage()">
        {{'buttons.save' | trans}}
      </button>

      <router-link class="btn btn-link btn-sm mr-2 mt-2 mt-md-0"
                   :to="{ name: 'choose-usd'}">
        <span>{{'buttons.back' | trans}}</span>
      </router-link>

    </div>
  </div>
  </form>

    <mdc-dialog v-model="isModalVisible"
                :title="'protocol.confirm_save_conflict_session' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                @accept="saveSession"
                @cancel="cancelSession">
    </mdc-dialog>

  </div>
</template>

<script>
  import {maintainStage} from '../../../mixins/maintainStage';

  export default {
    props: ['protocolId', 'phaseId', 'client', 'stageId', 'stage'],
    data() {
      return {
        apiUrl: '/protocols/assigned/vcd/',
      };
    },
    mixins: [maintainStage],
  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/MaintainStageUSD.vue